import React, { Component } from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import 'moment/locale/es';
import MomentLocaleUtils, {
  formatDate,
  parseDate
} from 'react-day-picker/moment';
import './daypicker.css';
import { addDays, calculateDefaultTimeLimit, getHolidaysDefault, stringToDate } from '../../../../../utils/DateUtil';
import simulatorConstants from '../config/config.simulator';


const modifiersStyles = {
  currentDisabled:{
    pointerEvents: 'none',
  }
}

const modifiers = {
  currentDisabled: new Date()
}

class DayPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorText: undefined,
    };
  }

  componentDidMount(){
    const { handleDayChange, setDefExpDate, disabledDays, expirationDate } = this.props;
    if(expirationDate === ''){
      const initialDay = new Date();
      const defaultTimeLimit = calculateDefaultTimeLimit(initialDay, disabledDays);
      setDefExpDate(defaultTimeLimit)
      handleDayChange(defaultTimeLimit);
    }
  }

  render() {
    const { expirationDate, defaultExpirationDate, timeLimit, handleDayChange, disabledDays } = this.props;
    const { errorText } = this.state;
    const today = new Date();

    const to = addDays(today, simulatorConstants.RANGE_TIME_DAP, 0);
    const holidays = stringToDate(disabledDays, 4, false, false);
    holidays.push({before: today})
    holidays.push({after: to})
    const allHolidays = holidays.concat(getHolidaysDefault(today, defaultExpirationDate));

    return (
      <React.Fragment>
        <b>Plazo</b>
        <br />
        <DayPickerInput
          formatDate={formatDate}
          parseDate={parseDate}
          dayPickerProps={{
            locale: 'es',
            localeUtils: MomentLocaleUtils,
            disabledDays: allHolidays,
            fromMonth: today,
            modifiers: modifiers,
            modifiersStyles: modifiersStyles
          }}
          inputProps={{
            readOnly: true
          }}
          placeholder="DD/MM/AAAA"
          onDayChange={handleDayChange}
          value={expirationDate}
        />
        <span className="dap_timelimit">
          {`${timeLimit} días`}
        </span>
        <br />
        <small>{errorText || 'Mínimo 7 días'}</small>
      </React.Fragment>
    );
  }
}

export default DayPicker;
